
/**
 * DOM selectors.
 */ const selectors = {
    mobileToggle: '[js-mobile-navigation="toggle"]',
    mobileMenu: '[js-mobile-navigation="mobileMenu"]'
};

document.addEventListener("DOMContentLoaded", function () {
/**
   * Node selectors.
*/ const nodeSelectors = {
        mobileToggle: document.querySelectorAll(selectors.mobileToggle),
        mobileMenu: document.querySelector(selectors.mobileMenu),
    };

    // Quantity box button click
    let btns = document.querySelectorAll('.qtybox .btnqty');
    btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            let input = this.parentElement.querySelector('input');
            let qty = parseInt(input.value);
            if (this.classList.contains('qtyplus')) {
                qty++;
            } else {
                if (qty > 1) {
                    qty--;
                }
            }
            qty = isNaN(qty) ? 1 : qty;
            input.value = qty;
            document.querySelector("input[name='update']").click();
        });
    });

    
    let body = document.querySelector('body')
    console.log("🚀 ~ body:", body)

    // Responsive edits
    // if (window.innerWidth > 980) {
        window.addEventListener('scroll', function () {
            let scroll = window.scrollY;
            if (scroll >= 1) {
                
                body.classList.add("header--scrolled");
            } else {
                body.classList.remove("header--scrolled");
            }
        });
    // }



    window.addEventListener('scroll', function () {
        let sticky = document.querySelector('[js-header="scrollHeader"');

        let scroll = window.scrollY;
        if (scroll >= 100) {
            // sticky.classList.add('fixed-header');
        } else {
            // sticky.classList.remove('fixed-header');
        }
    });

    // document.querySelector('.shifter-handle').addEventListener('touchstart', function() {
    //     document.querySelector(".gridlock.shifter").classList.toggle("shifter-open");
    // });


    let options = document.querySelectorAll('.select > select > option');

    setTimeout(function () {
        options.forEach((option, index) => {
            // Get the corresponding selecter-item element
            let selecterItem = document.querySelector('.selecter .selecter-item:nth-child(' + (index + 1) + ')');
            // Set the data-quantity attribute
            selecterItem.setAttribute('data-quantity', option.getAttribute('data-quantity'));
            // Set the data-isPre attribute
            selecterItem.setAttribute('data-isPre', option.getAttribute('data-isPre'));
            // Check the data-quantity value and add the 'oos' class if conditions are met
            if (parseInt(selecterItem.getAttribute('data-quantity')) < 1 && selecterItem.getAttribute('data-isPre') !== 'true') {
                selecterItem.classList.add('oos');
            }
        });
    }, 0)


});






// cookie
// !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function t(n,o){var i=u.raw?n:r(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(r,c,a){if(void 0!==c&&!e.isFunction(c)){if(a=e.extend({},u.defaults,a),"number"==typeof a.expires){var d=a.expires,f=a.expires=new Date;f.setTime(+f+864e5*d)}return document.cookie=[n(r),"=",i(c),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}for(var s=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],m=0,v=p.length;v>m;m++){var x=p[m].split("="),k=o(x.shift()),l=x.join("=");if(r&&r===k){s=t(l,c);break}r||void 0===(l=t(l))||(s[k]=l)}return s};u.defaults={},e.removeCookie=function(n,o){return void 0===e.cookie(n)?!1:(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});   
